query getNumberOfLandingpages($input: GetNumberOfLandingpagesInput!) {
  numberOfLandingpages: getNumberOfLandingpages(input: $input)
}
